module.exports = __webpack_public_path__ + "static/media/step-indicator-2.617a2b7f.svg";